import { convertToMillions } from '../../../dashboard/dashboard-utils';

export type ChartValueType = 'default' | 'money';

export function valueFormatter(type: ChartValueType | undefined, value: number): string {
  return type === 'money' ? convertToMillions(value) : `${value}`;
}
